<template>
  <el-pagination
    class="pagination"
    @current-change="handleCurrentChange"
    :current-page="parseInt(value.current_page)"
    background
    layout=" total,prev, pager, next, jumper"
    :page-size="value.per_page"
    :total="value.total"
  ></el-pagination>
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Object,
      default: Object
    }
  },
  methods: {
    handleCurrentChange(value) {
      this.value.current_page = value;
      this.scrollToTop();
      this.$emit("event", false); 
    },
    scrollToTop(){
      window.scrollTo({
        top:0,
        behavior:'auto'
      })
    }
  }
};
</script>
